import { LOGIN } from "../../common/apiUrl/login/loginUrls";
import { API } from "../../common/model/objectTypes";
import { loginApiInfo } from "../../utils/apiDescription/login/login";
import { API_BASE_URL } from "../../utils/constants";
import { loginRequestBody, loginResponseBody, refreshTokenRequestBody, refreshTokenResponseBody } from "../../utils/login/apiObjects";
import { loginJsonRequestCurl, refreshTokenJsonRequestCurl } from "../../utils/login/sampleJsonRequest";
import { loginAndRefreshTokenJsonResponse } from "../../utils/login/sampleJsonResponse";

const login: API = {
    name: "Login",
    url: `${API_BASE_URL}/${LOGIN.LOGIN_URL}`,
    method: "POST",
    apiInfo: loginApiInfo.login,
    requestBody: loginRequestBody,
    responseBody: loginResponseBody,
    jsonRequest: loginJsonRequestCurl,
    jsonResponse: loginAndRefreshTokenJsonResponse,
}

const refreshToken: API = {
    name: "Refresh Token",
    url: `${API_BASE_URL}/${LOGIN.REFRESH_TOKEN_URL}`,
    method: "POST",
    apiInfo: loginApiInfo.refreshToken,
    requestBody: refreshTokenRequestBody,
    responseBody: refreshTokenResponseBody,
    jsonRequest: refreshTokenJsonRequestCurl,
    jsonResponse: loginAndRefreshTokenJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Login':
            return login;
        case 'Refresh Access Token':
            return refreshToken;
    }
}